/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_First_LeadInputs */

const en_start_page_first_lead = /** @type {(inputs: Start_Page_First_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first client in the schedule.`)
};

const pl_start_page_first_lead = /** @type {(inputs: Start_Page_First_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pierwszy podopieczny w grafiku.`)
};

/**
* | output |
* | --- |
* | "Your first client in the schedule." |
*
* @param {Start_Page_First_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_first_lead = /** @type {((inputs?: Start_Page_First_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_First_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_first_lead(inputs)
	return en_start_page_first_lead(inputs)
});